export default "__VITE_ASSET__XG$TJO4u__"